<template>
  <div
    v-if="tags.length"
    class="patient-tag-badges"
  >
    <template v-if="withDesc">
      <div
        v-for="t in tags"
        :key="t.val"
        class="mb-1"
      >
        <span
          class="badge mr-1"
          :class="cls(t)"
          >{{ t.label }}</span
        >
        <span
          v-if="t.desc"
          class="small-text"
          >{{ t.desc }}</span
        >
      </div>
    </template>
    <template v-else>
      <span
        v-for="t in tags"
        :key="t.val"
        class="badge mr-1"
        :class="cls(t)"
        >{{ t.label }}</span
      >
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { resolveTags, tagClass } from "@/utils/patientTags";

export default {
  name: "PatientTagBadges",
  props: {
    tagIds: { type: Array, default: () => [] },
    withDesc: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({ tagList: "moduleMaster/getPatientTagList" }),
    tags() {
      const all = resolveTags(this.tagIds, this.tagList);
      return this.withDesc ? all.filter(t => t.desc) : all;
    },
  },
  methods: {
    cls(t) {
      return tagClass(t.color);
    },
  },
};
</script>
